import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { MvmNaviresService } from 'src/app/Service/mvm-navires.service';

@Component({
  selector: 'app-gestion-access',
  templateUrl: './gestion-access.component.html',
  styleUrls: ['./gestion-access.component.scss']
})
export class GestionAccessComponent implements OnInit {

  res= { Title: "", Msg: "",data:null};
  constructor(public global: Global, private service: MvmNaviresService) { }

  ngOnInit(): void {
  }

  lancer(numAutorisation) {
    this.service.getGestionAccessPortSOA(numAutorisation).subscribe(data => {
      if (data["numAutorisation"] == null) {
        this.res.Title = "Autorisation non valide";
        this.res.Msg = "Aucune autorisation trouvée avec ce numero : " + numAutorisation;
        this.res.data = null;
      }
      else {
        //en attente de verifier avec la date => nouvelle versin Portnet
        if (data["typeAcces"].toLowerCase()=="permanent") {
          if (data["etatBadge"].toLowerCase()=="s") {
            this.res.Title = "Autorisation suspendue";
            this.res.Msg = "le badge est suspendu, Pour plus d'info, merci de contacter la capitainerie";
            this.res.data = null;
          }
          else {
            this.StartActivity(data);
          }
        }
        else {
          if (data["dateValidation"] == null) {

            let dateDebut = data["dateDebut"].split('-')[2]+"/"+data["dateDebut"].split('-')[1]+"/"+data["dateDebut"].split('-')[0]
            let dateFin = data["dateFin"].split('-')[2]+"/"+data["dateFin"].split('-')[1]+"/"+data["dateFin"].split('-')[0]
            let debut = new Date(dateDebut);
            let fin = new Date(dateFin);
            let now = new Date();

            if (now < debut) {
              this.res.Title = "Autorisation non valide";
              this.res.Msg = "Vous êtes en avance votre autorisation prend effet le   : " + debut.toLocaleDateString();
              this.res.data = null;
            }
            else if (now > fin) {
              this.res.Title = "Autorisation non valide";
              this.res.Msg = "Vous êtes en retard votre autorisation a pris fin le  : " + fin.toLocaleDateString();
              this.res.data = null;
            }
            else {
              this.StartActivity(data);
            }
          }
          else {
            if (data["etatBadge"].toLowerCase()=="s") {
              this.res.Title = "Autorisation suspendue";
              this.res.Msg = "le badge est suspendu, Pour plus d'info, merci de contacter la capitainerie";
              this.res.data = null;
            }
            else {
              this.StartActivity(data);
            }
          }

        }
      }
    })
  }

  StartActivity(data){
    this.res.Title = "Autorisation valide";
    this.res.Msg = "";
    this.res.data = data;
  }

}
